export default __webpack_public_path__ + "static/media/0x7cdc0421469398e0f3aa8890693d86c840ac8931.d576a1f0.png";